import React from 'react';
import { makeStyles, withStyles, Typography, Paper } from '@material-ui/core';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import CachedIcon from '@material-ui/icons/Cached';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningIcon from '@material-ui/icons/Warning';
import { breakpoints } from '../../UIComponent/CommonStyle'

const useStyles = makeStyles(() => ({
    approveStatusIcon: {
        color: '#369E64',
        fontSize: 25
    },
    timelineContentContainer: {
        textAlign: 'left'
    },
    timelineContent: {
        display: 'inline-block',
        textAlign: 'center',
        width: 90,
        [breakpoints.up("sm")]: {
            width: 120,
        },
        minWidth: 50
    },
    approverName: {
        backgroundColor: '#384B63',
        color: '#FFF',
        borderRadius: '5px 5px 0 0',
        fontSize: 12
    },
    processingContent: {
        fontSize: 12
    },
}));

const ApprovedConnector = withStyles({
    root: {
        height: 70,
    },
})(TimelineConnector);

export default function Details({
    myLeave,

    firstProcessingStatusColor,
    secProcessingStatusColor,
    finalProcessingStatusColor,

    showFirstPending,
    showFirstApproved,
    showFirstRejected,
    showFirstNA,

    showSecPending,
    showSecApproved,
    showSecRejected,
    showSecNA,

    showFinalPending,
    showFinalApproved,
    showFinalRejected,
    showFinalNA,
    showFinalSeparator,

    firstApproveText,
    secApproveText,
    finalApproveText,
    showFirstApprover,
    showSecApprover,
}) {
    const classes = useStyles();
    return (
        <Timeline align="alternate">
            {showFirstApprover &&
                <TimelineItem>
                    <TimelineSeparator>
                        {showFirstPending && <CachedIcon className={classes.approveStatusIcon} style={{ color: firstProcessingStatusColor }} />}
                        {showFirstApproved && <CheckCircleIcon className={classes.approveStatusIcon} style={{ color: firstProcessingStatusColor }} />}
                        {showFirstRejected && <CancelIcon className={classes.approveStatusIcon} style={{ color: firstProcessingStatusColor }} />}
                        {showFirstNA && <WarningIcon className={classes.approveStatusIcon} style={{ color: firstProcessingStatusColor }} />}
                        <ApprovedConnector style={{ background: firstProcessingStatusColor }} />
                    </TimelineSeparator>
                    <TimelineContent className={classes.timelineContentContainer}>
                        <Paper className={classes.timelineContent}>
                            <Typography className={classes.approverName}>{myLeave.firstApprover}</Typography>
                            <Typography className={classes.processingContent}>{firstApproveText}</Typography>
                        </Paper>
                    </TimelineContent>
                </TimelineItem>
            }
            {showSecApprover &&
                <TimelineItem>
                    <TimelineSeparator>
                        {showSecPending && <CachedIcon className={classes.approveStatusIcon} style={{ color: secProcessingStatusColor }} />}
                        {showSecApproved && <CheckCircleIcon className={classes.approveStatusIcon} style={{ color: secProcessingStatusColor }} />}
                        {showSecRejected && <CancelIcon className={classes.approveStatusIcon} style={{ color: secProcessingStatusColor }} />}
                        {showSecNA && <WarningIcon className={classes.approveStatusIcon} style={{ color: secProcessingStatusColor }} />}
                        <ApprovedConnector style={{ background: secProcessingStatusColor }} />
                    </TimelineSeparator>
                    <TimelineContent className={classes.timelineContentContainer}>
                        <Paper className={classes.timelineContent}>
                            <Typography className={classes.approverName}>{myLeave.secApprover}</Typography>
                            <Typography className={classes.processingContent}>{secApproveText}</Typography>
                        </Paper>
                    </TimelineContent>
                </TimelineItem>
            }
            <TimelineItem>
                {showFinalSeparator &&
                    <TimelineSeparator>
                        {showFinalPending && <CachedIcon className={classes.approveStatusIcon} style={{ color: finalProcessingStatusColor }} />}
                        {showFinalApproved && <CheckCircleIcon className={classes.approveStatusIcon} style={{ color: finalProcessingStatusColor }} />}
                        {showFinalRejected && <CancelIcon className={classes.approveStatusIcon} style={{ color: finalProcessingStatusColor }} />}
                        {showFinalNA && <WarningIcon className={classes.approveStatusIcon} style={{ color: finalProcessingStatusColor }} />}
                    </TimelineSeparator>
                }
                <TimelineContent className={classes.timelineContentContainer}>
                    <Paper className={classes.timelineContent}>
                        <Typography className={classes.approverName}>HR</Typography>
                        <Typography className={classes.processingContent}>{finalApproveText}</Typography>
                    </Paper>
                </TimelineContent>
            </TimelineItem>
        </Timeline>
    )
}